






















































import { Vue, Component, Prop } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { Practice as IPractice } from "@/api/models/practice";
import { PracticeEdit as IPracticeEdit } from "@/api/models/practice-edit";
import { PracticeCreate as IPracticeCreate } from "@/api/models/practice-create";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { Course as ICourse } from "@/api/models/course";
import { AxiosError } from "axios";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";

@Component({
  components: { CPageButtons, CustomButton, SelectEntity, EditorWithFile }
})
export default class PracticeForm extends Vue {
  @Prop() practiceInfo?: IPractice;
  title!: string;
  body!: string;
  selectedCompany!: string;
  enabled: boolean = true;
  coursesList!: ICoursesList | any;
  selectedCourse!: string;
  showSpinner: boolean = false;
  courseIdForProp?: string | undefined;
  isSavingProcess: boolean = false;

  data() {
    return {
      title: undefined,
      myCompaniesList: undefined,
      selectedCompany: undefined,
      selectedCourse: undefined,
      coursesList: undefined,
      body: undefined,
      courseIdForProp: undefined
    };
  }

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  createPractice() {
    this.isSavingProcess = true;
    if (!this.practiceInfo) {
      let practice: IPracticeCreate = {
        title: this.title,
        body: this.body,
        enabled: this.enabled
      };
      api.PracticeApi.create(this.selectedCourse, practice)
        .then(() => {
          this.$router.push({ name: "courses" });
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        )
        .finally(() => {
          this.isSavingProcess = false;
        });
    } else {
      this.isSavingProcess = true;
      let practice: IPracticeEdit = {
        body: this.body,
        title: this.title,
        enabled: this.enabled
      };
      api.PracticeApi.edit(this.$route.params.courseId, practice)
        .then(() => {
          this.$router.push({
            name: "practiceView",
            params: {
              courseId: this.$route.params.courseId,
              practiceId: this.$route.params.practiceId
            }
          });
        })
        .catch(
          (error: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(`${error.response.data.message}`, {
                variant: "danger",
                title: this.$tc(this.$translate.Error)
              });
            }
          }
        )
        .finally(() => {
          this.isSavingProcess = false;
        });
    }
  }

  selectCourse(course: ICourse) {
    this.selectedCourse = course.id;
  }

  onCancel() {
    this.$router.push({ name: "Home" });
  }

  async onRemove() {
    try {
      this.isSavingProcess = true;
      await api.PracticeApi._delete(this.$route.params.courseId);
      await this.$router.push({
        name: "courseView",
        params: { courseId: this.$route.params.courseId }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isSavingProcess = true;
    }
  }

  mounted() {
    if (this.practiceInfo) {
      this.body = this.practiceInfo.body;
      this.title = this.practiceInfo.title;
      this.enabled = this.practiceInfo.enabled;
      this.courseIdForProp = this.$route.params.courseId;
    }
  }
}
